import { distinctUntilChanged, map, first, switchMap } from "rxjs/operators";
import { GeoCoords } from "../geo/GeoCoords";
export class CameraService {
    constructor(stateService, api, graphService) {
        this._api = api;
        this._stateService = stateService;
        this._graphService = graphService;
        this._currentNode$ = this._stateService.currentNode$;
        this._geoCoords = new GeoCoords();
        this._currentCameraSystems$ = this._currentNode$.pipe(distinctUntilChanged((node_prev, node) => {
            if (!node_prev.full)
                return true;
            return (node.frame.segment === node_prev.frame.segment &&
                node.frame.collection === node_prev.frame.collection);
        }), switchMap((node) => {
            return this.cacheCameras$(node).pipe(map((nodes) => {
                return nodes.filter((x) => x.frame.collection == node.frame.collection);
            }));
        }), distinctUntilChanged((nodes_prev, nodes) => {
            const ids_prev = nodes_prev.map((x) => {
                if (x.full)
                    return x.frame.capturesystem.id;
                return "-1";
            });
            const ids = nodes.map((x) => x.frame.capturesystem.id);
            const collections_prev = nodes_prev.map((x) => {
                if (x.full)
                    return x.frame.collection;
                return "";
            });
            const collections = nodes.map((x) => x.frame.collection);
            if (collections.some((val) => collections_prev.indexOf(val) == -1)) {
                return false;
            }
            if (ids.length !== ids_prev.length) {
                return false;
            }
            return ids.every((val) => ids_prev.indexOf(val) > -1) && ids_prev.every((val) => ids.indexOf(val) > -1);
        }));
    }
    get cameraConfigurations$() {
        return this._currentCameraSystems$;
    }
    cacheCameras$(node) {
        const sw = this._geoCoords.enuToGeodetic(-5, -5, 0, node.latLon.lat, node.latLon.lon, 0);
        const ne = this._geoCoords.enuToGeodetic(5, 5, 0, node.latLon.lat, node.latLon.lon, 0);
        return this._graphService.cacheBoundingBox$({ lat: sw[0], lon: sw[1] }, { lat: ne[0], lon: ne[1] }).pipe(map((node_candidates) => {
            return node_candidates.filter((node_candidate) => {
                const tdiff = Math.abs(Date.parse(node_candidate.frame.timestamp) - Date.parse(node.frame.timestamp));
                return (tdiff < 20 &&
                    node_candidate.frame.collection == node.frame.collection &&
                    node_candidate.frame.campaignID == node.frame.campaignID);
            });
        }), map((nodes) => {
            const grouped_nodes = nodes.reduce((r, a) => {
                if (r.map((x) => x.frame.capturesystemID).indexOf(a.frame.capturesystemID) == -1)
                    r.push(a);
                return r;
            }, []);
            return grouped_nodes;
        }));
    }
    moveToCamera$(capturesystemID) {
        return this._currentNode$.pipe(first(), switchMap((node) => this.cacheCameras$(node)), map((allnodes) => allnodes.filter((node_candidate) => node_candidate.frame.capturesystemID == capturesystemID)), map((filtered_nodes) => {
            if (filtered_nodes.length > 0)
                return filtered_nodes[0].key;
            return "";
        }));
    }
}
//# sourceMappingURL=CameraService.js.map